"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isLastPresenter = isLastPresenter;
exports.isMediaSolo = isMediaSolo;
exports.isMultiUserLayout = isMultiUserLayout;
exports.isPresenter = isPresenter;
exports.isPresenterSolo = isPresenterSolo;
exports.isScreenShare = isScreenShare;
exports.isScreenShareSolo = isScreenShareSolo;
exports.isSingleLayout = isSingleLayout;
exports.selectSceneLayout = selectSceneLayout;
var _constants = require("../../constants/");
/**
 * @param {{}} sceneLayout
 */
function isMultiUserLayout(sceneLayout) {
  return [_constants.GRID, _constants.SIDE_BY_SIDE, _constants.FEATURED_MEDIA, _constants.FEATURED_SCREEN, _constants.FEATURED_PRESENTER].some(function (layout) {
    return layout.title === sceneLayout.title;
  });
}

/**
 * Checks if layout is SINGLE
 * @param {{}} sceneLayout
 */
function isSingleLayout(sceneLayout) {
  return sceneLayout.title === _constants.SINGLE.title;
}

/**
 * Checks if source is a media source.
 * This should not include AUDIO_FILE since they should NOT change layout.
 * @param {{}} source
 * @returns Boolean
 */
function isMediaSource(source) {
  var sourceType = source.type;
  return [_constants.IMAGE_FILE, _constants.PDF_FILE, _constants.VIDEO_FILE, _constants.MEDIA].includes(sourceType);
}

/**
 * Checks if source is screen share
 * @param {{}} source
 */
function isScreenShare(source) {
  return source.type === _constants.SCREEN_PRESENTER;
}

/**
 * Checks if source is presenter
 * @param {{}} source
 */
function isPresenter(source) {
  return source.type === _constants.CAMERA_PRESENTER;
}

/**
 *
 * @param {Array} sources
 * @param {{}} source
 */
var containsSource = function containsSource(sources, source) {
  if (!sources.length) return true;
  return sources.some(function (s) {
    return s._id === source._id;
  });
};

/**
 * @param {{}} sceneLayout
 * @param {Array} sources
 */
function isMediaSolo(sceneLayout, sources) {
  return isSingleLayout(sceneLayout) && sources.some(function (s) {
    return isMediaSource(s);
  });
}

/**
 * @param {{}} sceneLayout
 * @param {Array} sources
 */
function isScreenShareSolo(sceneLayout, sources) {
  return isSingleLayout(sceneLayout) && sources.some(function (s) {
    return isScreenShare(s);
  });
}

/**
 * @param {{}} sceneLayout
 * @param {Array} sources
 */
function isPresenterSolo(sceneLayout, sources) {
  return isSingleLayout(sceneLayout) && sources.some(function (s) {
    return isPresenter(s);
  });
}

/**
 * @param {{}} sceneLayout
 * @param {Array} sources
 */
function isLastPresenter(sources) {
  return sources.filter(function (s) {
    return s.type === _constants.CAMERA_PRESENTER;
  }).length === 1;
}

/**
 * Decide the sceneLayout based on user activity
 * @param {{}} sceneLayout
 * @param {{}} source
 * @param {Array} sources
 */
function selectSceneLayout(sceneLayout, source, sources) {
  // In a featured media/screen layout and we toggle a media source - switch to single layout
  if (isMultiUserLayout(sceneLayout) && containsSource(sources, source)) {
    // Switch to grid/single
    if (isMediaSource(source) || isScreenShare(source)) {
      return sources.length > 2 ? _constants.GRID : _constants.SINGLE;
    }

    // If last presenter switch to single source layout otherwise use the same layout
    if (isPresenter(source)) {
      return isLastPresenter(sources, source) ? _constants.SINGLE : sceneLayout;
    }
  }

  // In a featured media/screen layout and we add a screen-share/media source - switch to featured media/screen layout
  if (isMultiUserLayout(sceneLayout) && !containsSource(sources, source)) {
    // Switch to featured media
    if (isMediaSource(source)) {
      return _constants.FEATURED_MEDIA;
    }

    // Switch to featured screen
    if (isScreenShare(source)) {
      return _constants.FEATURED_SCREEN;
    }
  }

  // If presenter in SOLO layout
  if (isPresenterSolo(sceneLayout, sources)) {
    // If add live media source - switch to featured media
    if (isMediaSource(source)) return _constants.FEATURED_MEDIA;

    // if add live screen share - switch to featured screen
    if (isScreenShare(source)) return _constants.FEATURED_SCREEN;

    // If add another presenter - switch to grid
    if (isPresenter(source) & !containsSource(sources, source)) return _constants.GRID;
  }

  // If a media source in program and source is presenter - switch to featured media layout
  if (isMediaSolo(sceneLayout, sources) && isPresenter(source)) {
    return _constants.FEATURED_MEDIA;
  }
  if (isScreenShareSolo(sceneLayout, sources) && isPresenter(source)) {
    return _constants.FEATURED_SCREEN;
  }
  return sceneLayout;
}